import React from 'react';
import { useParams } from 'react-router-dom';
import DownloadButton from './DownloadButton';
import { makeLocalDateStr } from '../../utilities/dates';

export default function MeetingsCard({ meetingData }) {
  let { selectName } = useParams();

  const meeting_headers = [
    { label: 'Name', key: 'meeting_name' },
    { label: 'Type', key: 'meeting_type' },
    { label: 'Location', key: 'meeting_location' },
    { label: 'Date', key: 'date_time' },
    { label: 'Document Files', key: 's3_prefix' }
  ];

  const fileName = `Meetings_${selectName}`;

  return (
    <div
      className='col-xl-1-12'
      style={{ margin: '10px', background: '#1A4565', border: 'double' }}
    >
      <div className='card' style={{ border: 'none', width: '100%' }}>
        <div
          className='card-body'
          style={{ width: '100%', background: 'lightBlue' }}
        >
          <h3 className='card-title' style={{ marginLeft: '10px' }}>
            Meetings
          </h3>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Location</th>
                <th>Date</th>
                <th>Documents</th>
              </tr>
            </thead>
            <tbody>
              {meetingData.map((meeting, idx) => (
                <tr key={idx}>
                  <td style={{ textAlign: 'center' }}>
                    {meeting.meeting_name}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {meeting.meeting_type}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {meeting.meeting_location.String}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {makeLocalDateStr(meeting.date_time)}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <a
                      // target='_blank'
                      style={{ color: 'blue', textAlign: 'right' }}
                      rel='noreferrer'
                      href={`/fileExplorer?s3_prefix=outreach/meetings/${meeting.meeting_id}`}
                    >
                      Meeting (ID-{meeting.meeting_id})
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <hr style={{ color: 'grey' }} />
        </div>
      </div>
      <DownloadButton
        new_data={meetingData}
        headers={meeting_headers}
        file={fileName}
      />
    </div>
  );
}
